import { GameVars } from "./GameVars";
import { GameManager } from "./GameManager";

// audiosprite -e "mp3,ogg" -o ../assets/audio/audiosprite *.mp3 -f howler
export class AudioManager {

    public static sound: Howl;

    private static rate: number;
    private static loopID: number; 

    public static init(): void {

        AudioManager.sound.mute(GameVars.gameData.muted);
        AudioManager.rate = 1;
        AudioManager.loopID = null;
    }

    public static toggleAudioState(): void {

        GameVars.gameData.muted = !GameVars.gameData.muted;
        GameManager.writeGameData();
        
        AudioManager.sound.mute(GameVars.gameData.muted);
    }

    public static playSound(key: string, loop?: boolean, volume?: number): void {

        loop = loop || false;
        volume = volume || 1;

        const id = AudioManager.sound.play(key);
        
        AudioManager.sound.volume(volume, id);

        if (loop) {

            if (AudioManager.loopID) {
                AudioManager.sound.stop(AudioManager.loopID);
            }

            AudioManager.sound.loop(true, id);

            AudioManager.loopID = id;
        }
    }

    public static setLoopVolume(v: number): void {
        
        AudioManager.sound.volume(v);
    }

    public static increaseLoopRate(): void {

        AudioManager.rate *= 1.075;

        AudioManager.sound.rate(AudioManager.rate, AudioManager.loopID);
    }

    public static onBlur(): void {
        
        if (!GameVars.gameData.muted && AudioManager.sound) {
            AudioManager.sound.mute(true);
        }
    }

    public static onFocus(): void {
        
        if (!GameVars.gameData.muted && AudioManager.sound) {
            AudioManager.sound.mute(false);
        }
    }
}
